<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import PageHeader from "@/components/page-header";
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import BirimSecimi from "../ouserbirimyetki/birimsecimi.vue";
import BirimSecimi2 from "../FormComponet/BirimSecimiAnaBirim3.vue";
import addpersonel from "../opersonel/index"
import store from "@/state/store";
const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 500);
};

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Hoşgeldiniz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    treeselect,
    BirimSecimi,
    BirimSecimi2,
    addpersonel
  },
  data() {
    return {
      title: this.$t("userroles.Title"),
      items: [
        {
          text: this.$t("userroles.Title"),
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      KullaniciBilgileri: null,
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      //Kullanicilar: {},
      UserType: null,
      UserTypes: [
        { id: 1, label: "Firma Kullanıcıları" },
        { id: 2, label: "Personeller" },
        { id: 3, label: "Öğrenciler" },
      ],
      KullanicilarTable: {},
      KullaniciRolleriGrup: {},
      KullaniciRolleri: {},
      KullaniciAra: null,
      YetkiAra: null,
      BirimAra: null,
      SeciliKullaniciYetkileri: {},
      SeciliYetkiKullaniciliari: {},
      Roles: [],
      KullanicilarArray: [],
      YetkiArray: [],
      Tab: 1,
      KullaniciAvatar: null,
      birimbazliyetkiliste: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  watch: {
    KullaniciAra() {
      this.KullaniciAvatar = this.KullanicilarArray.filter((notification) =>
        notification.id.includes(this.KullaniciAra)
      );
    },
    BirimAra(newValue) {
      if (newValue) {
        this.BirimGet(newValue);
      }
    },
  },
  methods: {
      yetki_kontrol(yetki){


      var sonuc = this.KullaniciBilgileri.indexOf(yetki);

      return sonuc;

      },
    loadOptions({ action, callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          this.options = this.KullanicilarArray;
          callback(null, this.options);
        });
      }
    },

    Get() {
      this.KullaniciRolleri = [];

      this.ActionsGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-roles",
        Page: this.PageToplu,
      }).then((res) => {
        res.Data = res.Data.sort(function(a, b) {
          return a.Title.localeCompare(b.Title);
        });
        this.KullaniciRolleriGrup = this.groupBy(
          res.Data.filter((x) => x.Group === "Strateji Bilgi Sistemi"),
          "Group"
        );

        this.KullaniciRolleri = res.Data;
        for (let i = 0; i < res.Data.length; i++) {
          if (res.Data[i].Group == "Strateji Bilgi Sistemi") {
            this.YetkiArray.push({
              id: res.Data[i].NormalizedName,
              label: res.Data[i].Name,
            });
          }
        }
      });

      // this.kullanici_yukle();
    },
    BirimGet(BirimId) {
      this.ActionsFilterGet({
        Service: "ouserbirimyetki/birimbazliyetkiliste",
        Page: this.PageToplu,
        Filter: "&Birimid=" + BirimId + "&Uygulamaadi=Strateji Bilgi Sistemi",
      }).then((res) => {
        this.birimbazliyetkiliste = res.Data;
      });
    },
    kullanici_yukle(name) {
      if (name.length > 2) {
        //this.Kullanicilar=[];
        this.KullanicilarArray = [];
        let Page = {
          PageNumber: "1",
          PageSize: "50",
        };
        let Filter = "&name=" + name;
        if (this.UserType != null && this.UserType != "") {
          Filter += "&usertype=" + this.UserType;
        }

        this.ActionsFilterGet({
          Service: this.$config.API_ACCOUNT_URL + "Account/get-users",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          //this.Kullanicilar = res.Data;
          for (let i = 0; i < res.Data.length; i++) {
            this.KullanicilarArray.push({
              id: res.Data[i].Email,
              label:
                res.Data[i].FirstName +
                " " +
                res.Data[i].LastName +
                "  /" +
                res.Data[i].Email,
              avatar: res.Data[i].AvatarUrl,
              userid: res.Data[i].Id,
            });
          }
        });

        /*
          this.ActionsGet({
            Service: this.$config.API_ACCOUNT_URL + "Account/get-users",
            Page: this.Page,
          }).then((res) => {
            this.KullanicilarTable = res.Data;
            this.Page.PageDataSize = res.TotalCount;
          }); */
      }
    },

    KullaniciYetkiSorgu(kullanici) {
      this.ActionsFilterGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-userroles",
        Page: this.PageToplu,
        Filter: "&email=" + kullanici,
      }).then((res) => {
        this.SeciliKullaniciYetkileri = res.Data;

        if (Array.isArray(res.Data.Roles)) {
          this.Roles = res.Data.Roles;
        } else {
          this.Roles = [];
        }
      });
    },
    Secilmis_Idler(secilmis) {
      this.BirimAra = secilmis;
    },
    YetkiKullaniciSorgu(yetki) {
      this.ActionsFilterGet({
        Service: this.$config.API_ACCOUNT_URL + "Account/get-users-in-role",
        Page: this.PageToplu,
        Filter: "&role=" + yetki,
      }).then((res) => {
        this.SeciliYetkiKullaniciliari = res.Data;
      });
    },

    groupBy: function(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },

    RolesPost(checked, value) {
      let FormData = {
        Email: this.SeciliKullaniciYetkileri.Email,
        Role: value,
      };
      if (checked == true) {
        this.Post(
          this.$config.API_ACCOUNT_URL + "Account/add-userroles",
          FormData
        );
      } else {
        this.Post(
          this.$config.API_ACCOUNT_URL + "Account/delete-userroles",
          FormData
        );
      }
    },
  },
    created() {

    this.KullaniciBilgileri = store.getters["auth/UserRolles"];



  },
};
</script>

<template>
  <Layout>
    <PageHeader title="" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="card-body">
            <h5 class="h4 card-title">
              {{ $t("userroles.page.yetkiislemleri") }}
            </h5>
            <p class="card-title-desc">
              {{
                $t(
                  "userroles.page.kullanicilaricinyetkinedirmeveyetkilistelemeekrani"
                )
              }}
            </p>

            <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            >
              <b-tab active @click="Tab = 1">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.kullaniciyetkilendirme")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.kullaniciara") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkilendirmekistediginizkullaniciyiseciniz"
                      )
                    }}
                  </p>
                  <b-form-group
                    class="col-lg-12 mb-3"
                    id="example text"
                    label-for="text"
                    label="Kullanıcı Türü"
                  >
                    <treeselect
                      :multiple="false"
                      :options="UserTypes"
                      placeholder="Seçiniz..."
                      v-model="UserType"
                      :key="UserType"
                    />
                    <treeselect-value :value="UserType" />
                  </b-form-group>

                  <div class="col-lg-12">
                    <b-form-group
                      class="col-lg-12 mb-3"
                      id="example text"
                      label-for="text"
                      label="Kullanıcılar"
                      v-if="UserType != null"
                    >
                      <treeselect
                        :clear-search-on-select="true"
                        :load-options="loadOptions"
                        placeholder="Seçiniz..."
                        name="KullaniciAra"
                        v-model="KullaniciAra"
                        :cacheOptions="false"
                        :multiple="false"
                        searchPromptText="Aramak için yazın..."
                        @search-change="kullanici_yukle($event)"
                        :async="true"
                        @select="KullaniciYetkiSorgu($event.id)"
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-tab>

              <b-tab @click="Tab = 2">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("userroles.page.yetkilistele")
                  }}</span>
                </template>

                <div class="mx-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.yetkiler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkiyebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12">
                    <treeselect
                      :multiple="false"
                      :options="YetkiArray"
                      placeholder="Seçiniz..."
                      v-model="YetkiAra"
                      @select="YetkiKullaniciSorgu($event.id)"
                    />
                  </div>
                </div>
              </b-tab>

              <b-tab @click="Tab = 3">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                    {{ $t("userroles.page.birimliste") }}
                  </span>
                </template>

                <div class="mx-5 mb-5">
                  <h4 class="card-title">
                    {{ $t("userroles.page.yetkiler") }}
                  </h4>
                  <p class="card-title-desc">
                    {{
                      $t(
                        "userroles.page.yetkiyebaglikullanicilarigormekcinsecimyapin"
                      )
                    }}
                  </p>
                  <div class="col-lg-12 mb-5">
                    <BirimSecimi2
                      :title="''"
                      :title_class="'mb-3'"
                      :closeOnSelect="true"
                      :sutun="'0'"
                      :multiple="false"
                      :YetkiKontrol="1"
                      :personel_id="null"
                      :BirimTipId="null"
                      @Secilmis_Idler="Secilmis_Idler($event)"
                      style="width: 100%; max-width: 100%; height: auto;"
                    />
                  </div>
                </div>
              </b-tab>

              <b-tab @click="Tab = 4"          v-if="yetki_kontrol('StrKullaniciEkleme') >= 0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                    Kullanıcı Ekleme
                  </span>
                </template>

                <div class="mx-5 mb-5">
                  <h4 class="card-title">
                    Kullanıcı Bilgileri
                  </h4>
<addpersonel />
                  

     
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="KullaniciAra && Tab == 1">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ this.$t("userroles.page.kullaniciyetkilendirmeekrani") }}
          </h5>
          <p class="card-title-desc">
            <img
              v-if="KullaniciAvatar[0].avatar"
              class="rounded-circle header-profile-user"
              :src="
                KullaniciAvatar[0].avatar
                  ? $config.AVATAR_URL + KullaniciAvatar[0].avatar
                  : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAJ/UExURUdwTCEgIB8fHyAfHyAfHyAfHyAfHx8eHiAfHx8eHiAfHyAfHyAfHx8eHiAfH5jU5h8eHiAfHyAfHyAfHx8eHh8eHiAfHyAfIAQBAxgWFiEhISEgIAwCACAgIB0bGi40NhkVFCAfH5za8FBncENVXKTm95vZ8Jza8J7c8R0bGhMTEx0cHCAfHyEgH73//yEgIJ7c8QAAAIfF6TM7PwwJCh4cHHm45SAfHyAfH5za8CAfH5za8Jza8Jza8Jza8CAfH5za8G6VokRVWxIKCJza8JvY7pza8DtITTlFSZ3b8AMHCgAABJza8ElBPDA4PFVLRK3z/zEvLRcXGEVBPTA5PJza8AADB5vZ74XD6QIAAIrJ67T+/4HA6BAIByAfH4zK7IrI6zE4O7D5/yAfHwEAACIgIJza8BUWGAACBhoaGvXLsQ0PEZ/g957c8RATFf/oy1p4hfzRticqLIC+6Jrm///jxiMiIvDEq//Xu/bHq//fxG5eVRgXF////P/z0P/22lNHQv/gv//877H5/xcTEhUOC76cicyolCcjIf/avdivlpvY7mZaUQMHC1lNRfrNsPTJr//o0v/cwf3WuHtnXIshF4VuYvTEqfrcyM+oqOrW1PTm4v716zM7PqHf8v/t1SkpJsD//1RueGebxaPn/IXK/TVIV3OapbmXheK0mNuymv/GrdWZhu/Tx+u7pI54adymkf/658+dlMifn+S1mafq+7uhizYvLeLCufLs7/rk1mNVTf/NrtOskqeHd8aXlXFgVv/kwZU1LNW1neK9tJAuJsCMirJwa+nKv9zFx2CRtVuKronG6naszSUnKUZaZG+TmUFPU3agr3GkxIu8xSfH+3sAAABzdFJOUwD97RwqJTMat/4VL6DlCwmSOh2qV77yhGEIms8njIj9+xEk6wESA6CMcwRtUGQlwnjIs9iu9u3fsS5e3hvwhB66hguP9eJfotdT9nPf4o7mPNW62Kc/5MnTMeRzzcTG3/LkYv////////////////////54WQMpAAACTklEQVQYGXXABVMiYRgA4BdYdhkExa5TR8Xuvu7u7v5g2V06XFGxO7C72+vu7s74Qaczd87sIg/85yeUJMMCsUK+FFzIEEISvwSZxF8iSwpEczyBT4L4xMAXhniE4CIQ8QRgwCMWID458PgipEYag0ZD07TGYHCgOcuBI1GIWA3lqEcOrVbrUNdXUzSLfIHDB7EG7fXGi411tRdq6y7dedrl1KjTgGMNop3PSm+WGO35+fkNHSUlpT0U8geO4ABneUX7w9tXWxmGKXzU/7HyyX2tBLhCVT0vh/q7b7W3MW1Fb169H6p4TIXAP1IRQfiIMV/qRUXl8+4HHUwnY//w9l1lZ7kzHBP7EIRICpg3juMemLd2zGwcHOjrLbjB9PYNDI72sgYc88Bx3BsDQiSN9FQCpFDFxrKyVvO1KwXmwtGy0i4qBUDpGSkVEbDA73D5vYIGo/2y3Vhkfl28PQl4NoQABAdl79vV0lzc3LLnwP4dBPB4rbNkwbwM1byMRHAVk7qe3gIAyWpWIBCwKAgWFTS8dfdBQY5cIMsRsv6wuARLhIU+rUBhKCQgFNwIPrYkTR6uVqjD80LBvWxhIFKgsLxT4IYy9XyWJbo6ujo64tyJvbGwiM1H9OM/kalmosb0bXhct2m1F/DExpG6KZPqxy/Vd9XsrGriro5cEQVcUSSp05s+T0XU/HGM6T6Z9DqSjAcur7Vkk77KNjnzu+rrzKStSt9ErloGfOk7yRGr1Tb9ZdpmtY6QG+NWgivlofTMk2dyz+YeP5oZvy0GFvwFlSbPVswTomsAAAAASUVORK5CYII='
              "
            />
            {{ this.$t("userroles.page.ekampusicin") }}
            <code>{{ KullaniciAra }}</code>
            {{ this.$t("userroles.page.yetkilendirmeekrani") }}
          </p>

          <div class="row">
            <div class="col-lg-6">
              <div class="mt-4 mt-lg-0">
                <h5 class="font-size-14 mb-3 w-100">
                  {{ Object.keys(KullaniciRolleriGrup)[0] }}
                </h5>

                <div
                  class="form-check form-switch form-switch-md mb-3"
                  v-for="(Roller, index) in Object.values(
                    KullaniciRolleriGrup
                  )[0]"
                  :key="index"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :id="Roller.Name"
                    v-model="Roles"
                    :value="Roller.Name"
                    @input="
                      RolesPost($event.target.checked, $event.target.value)
                    "
                  />
                  <label class="form-check-label" :for="Roller.Name">
                    {{ Roller.Title }}
                  </label>
                </div>
              </div>
            </div>

            <div class="d-none d-lg-block col-lg-1 text-center">
              <div
                style="border-left: 2px solid #ddd; height: 100%; margin: 0 auto;"
              ></div>
            </div>

            <div class="col-lg-5">
              <div class="mt-4 mt-lg-0 mb-3" style="height: 300px">
                <BirimSecimi
                  :Userid="KullaniciAvatar[0].userid"
                  title="Strateji Bilgi Sistemi"
                  Uygulamaid="9626c24b-c3c5-4d70-a9c8-d040ddee9fa9"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="YetkiAra && Tab == 2">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            {{ $t("userroles.page.listelenenyetki") }}
            <code>{{ YetkiAra }}</code>
            {{ $t("userroles.page.yetkilikullanicilar") }}
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t("userroles.table.FirstName") }}</th>
                  <th scope="col">{{ $t("userroles.table.LastName") }}</th>
                  <th scope="col">{{ $t("userroles.table.Email") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(Kullanici, index) in SeciliYetkiKullaniciliari"
                  :key="index"
                >
                  <td>{{ Kullanici.FirstName }}</td>
                  <td>{{ Kullanici.LastName }}</td>
                  <td>{{ Kullanici.Email }}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12" v-if="BirimAra && Tab == 3">
      <div class="card">
        <div class="card-body">
          <h5 class="h4 card-title">
            {{ $t("userroles.page.birimbazliyetkilikullanicilar") }}
          </h5>
          <p class="card-title-desc">
            <code>{{ birimbazliyetkiliste[0].Birimadi }}</code>
          </p>

          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr style="text-align:center">
                  <th rowspan="2">Yetkili Personel</th>
                  <th :colspan="Object.values(KullaniciRolleriGrup)[0].length">
                    Yetkiler
                  </th>
                </tr>
                <tr>
                  <th
                    style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; word-break: break-word; height: auto; vertical-align: middle; padding: 10px;"
                    v-for="(item, index) in Object.values(
                      KullaniciRolleriGrup
                    )[0]"
                    :key="index"
                  >
                    {{ item.Title }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(Kullanici, index) in birimbazliyetkiliste"
                  :key="index"
                >
                  <td>{{ Kullanici.Adi + " " + Kullanici.Soyadi }}</td>
                  <td
                    v-for="(yetki, yIndex) in Object.values(
                      KullaniciRolleriGrup
                    )[0]"
                    :key="yIndex"
                    style="text-align:center;"
                  >
                    {{
                      Kullanici.Yetki.split(", ").includes(yetki.Name)
                        ? "x"
                        : ""
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
            <b-pagination
              class="pagination pagination-rounded justify-content-end mb-2"
              v-model="DefaultPage"
              :total-rows="Page.PageDataSize"
              :per-page="Page.PageSize"
              aria-controls="my-table"
              @input="ChangePage(DefaultPage)"
            >
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 1px solid #ddd; /* Çizgiler */
  padding: 10px; /* Hücre içi boşluk */
  text-align: center;
  vertical-align: middle;
}

th {
  background-color: #2c3e50; /* Arka plan koyu */
  color: white;
  font-weight: bold;
}
</style>
